export default __webpack_public_path__ + "static/media/preview.f1ee393a.svg";